import styled from 'styled-components'

type FlexContainerProps = {
  gap?: string
  height?: string
  justifyContent?: string
}

export const FlexContainer = styled.div<FlexContainerProps>`
  display: flex;
  align-items: center;
  justify-content: ${(props) => props.justifyContent};
  gap: ${(props) => props.gap || '8px'};
  height: ${(props) => props.height};
`

export const EqualHeightCardContainer = styled.div({
  display: 'flex',
  flexDirection: `column`,
  height: '100%',
})
